import { httpClient } from '../http/fetch';

import * as Account from './account';
import { address } from './address';
import AppService from './app';
import * as Catalog from './catalog';
import CategoriesService from './categories';
import * as Checkout from './checkout';
import LocationService from './location';
import ModularContentService from './modular-content';
import NewTailService from './new-tail';
import NewsletterService from './newsletter';
import RegionService from './region';
import RichRelevanceService from './rich-relevance';
import SaleOrderService from './sale-order';
import SearchService from './search';
import SiteMapServices from './site-map';
import UserService from './user';
import UserContextService from './user-context';
import VouchersService from './vouchers';
import WishlistService from './wishlist';

export const Services = {
  Account: {
    Addresses: Account.Addresses(httpClient),
    CreditCards: Account.CreditCards(httpClient),
    Profile: Account.Profile(httpClient),
  },
  Address: {
    getAddressByPostalCode: address.getAddressByPostalCode(httpClient),
  },
  App: AppService(httpClient),
  Catalog: {
    Crosses: Catalog.Crosses(httpClient),
    Payment: Catalog.Payment(httpClient),
    Product: Catalog.Product(httpClient),
    Review: Catalog.Review(httpClient),
    Service: Catalog.Service(httpClient),
    Store: Catalog.Store(httpClient),
  },
  Categories: CategoriesService(httpClient),
  Checkout: {
    Cart: Checkout.Cart(httpClient),
    Payment: Checkout.Payment(httpClient),
    CreditCard: Checkout.CreditCard(httpClient),
  },
  Location: LocationService(httpClient),
  ModularContent: ModularContentService(httpClient),
  NewTail: NewTailService(httpClient),
  Newsletter: NewsletterService(httpClient),
  Region: RegionService(httpClient),
  RichRelevance: RichRelevanceService(httpClient),
  SaleOrder: SaleOrderService(httpClient),
  Search: SearchService(httpClient),
  SiteMap: SiteMapServices(httpClient),
  User: UserService(httpClient),
  UserContext: UserContextService(httpClient),
  Vouchers: VouchersService(httpClient),
  Wishlist: WishlistService(httpClient),
};
